import {LOCALE_DEFAULT} from '#lit/common/constants/index.js';
import type {LocalizedDestinations} from '#lit/common/locale/destination.js';
import {SupportedLocales} from '#lit/types/locale.js';
import type {AnyObject} from '#types';

class Locale {
  current: SupportedLocales = this.getLocale();

  getLocale() {
    if (navigator.languages) {
      const browserLocale: string = navigator.language.split('-')[0];
      return this.getSupportedLocaleForValue(browserLocale);
    }
    return LOCALE_DEFAULT;
  }

  getSupportedLocaleForValue(value: unknown): SupportedLocales {
    if (
      typeof value === 'string' &&
      Object.values<string>(SupportedLocales).includes(value)
    ) {
      return value as SupportedLocales;
    }
    console.warn(
      `[${value}] is not a supported locale. Falling back to default [${LOCALE_DEFAULT}]`
    );
    return LOCALE_DEFAULT;
  }

  buildDestinationLocalizer<TModel extends AnyObject>(localeObject: AnyObject) {
    return function (model: TModel) {
      const localizedDestination = model.destination
        ?.platform_type as LocalizedDestinations;
      return localeObject[localizedDestination] ?? localeObject;
    };
  }
}

export const locale = new Locale();
